import { t } from "@/i18n-js/instance";
import { InputFilterComparator } from "@circle-react-shared/Filter/FilterTypes/InputFilterComparator/InputFilterComparatorV2";
import type { StringComparatorParam } from "@circle-react-shared/Filter/FilterTypes/InputFilterComparator/stringComparators";
import {
  handleStringComparatorApply,
  renderTextSelectedItem,
  stringComparatorsIncludingExistence,
} from "@circle-react-shared/Filter/FilterTypes/InputFilterComparator/stringComparators";
import { Filter } from "@circle-react-shared/FilterV3";
import { useAudienceSearchContext } from "../AudienceSearchContext";

const localeNamespace = "members_directory.header.search.filters";

interface NameFilterProps {
  isInitialOpen?: boolean;
  onApply?: (value: StringComparatorParam | null) => void;
  param: StringComparatorParam;
}

export const NameFilter = ({
  isInitialOpen,
  onApply,
  param,
}: NameFilterProps) => {
  const { isContactsSearch } = useAudienceSearchContext();

  return (
    <Filter onApply={value => handleStringComparatorApply(value, onApply)}>
      <Filter.Chip renderSelectedValue={() => renderTextSelectedItem(param)}>
        {t([localeNamespace, "name"])}
      </Filter.Chip>

      <Filter.Popover
        title={t([localeNamespace, "name_title"])}
        isInitialOpen={isInitialOpen}
      >
        <InputFilterComparator
          name="name"
          param={param}
          placeholder={t([localeNamespace, "name_placeholder"])}
          comparators={
            isContactsSearch ? stringComparatorsIncludingExistence : undefined
          }
        />
      </Filter.Popover>
    </Filter>
  );
};
